import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const SlotPlaceholder = styled.div``;

type ContainerProps = {
  $isSetMinContainerHeight?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  z-index: 1;

  ${props =>
    props.$isSetMinContainerHeight &&
    css`
      ${theme.breakpoints.only("mobile")} {
        margin-block-end: var(--mobile-widget-gap, 16px);
        padding-block: var(--widget-extra-padding, 12px);
      }

      ${theme.breakpoints.only("tablet")} {
        margin-block-end: var(--mobile-widget-gap, 16px);
        padding-block: var(--widget-extra-padding, 12px);
      }

      ${SlotPlaceholder} {
        ${theme.breakpoints.only("mobile")} {
          min-block-size: 180px;
        }

        ${theme.breakpoints.only("tablet")} {
          min-block-size: 270px;
        }
      }
    `}
`;

type SlotContentProps = {
  $isSetMinHeight?: boolean;
};

export const SlotContent = styled.div<SlotContentProps>`
  line-height: 0;

  ${props =>
    props.$isSetMinHeight &&
    css`
      ${theme.breakpoints.only("mobile")} {
        min-block-size: 180px;
      }

      ${theme.breakpoints.only("tablet")} {
        min-block-size: 270px;
      }
    `}

  > div[id$="__container__"] {
    inline-size: 100%;

    text-align: center;
  }
`;
